import { render, staticRenderFns } from "./VAvatar.vue?vue&type=template&id=acd94580&scoped=true&"
import script from "./VAvatar.vue?vue&type=script&lang=ts&"
export * from "./VAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./VAvatar.vue?vue&type=style&index=0&id=acd94580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd94580",
  null
  
)

export default component.exports